import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ContentfulService } from '@services/billing/contentful-interfaces'
import { ContentService } from '@services/content/content.service'
import { IamService } from '@services/iam.service'
import { combineLatest, Subscription } from 'rxjs'
import { filter, map, take } from 'rxjs/operators'
import { AppService } from 'src/app/app.service'
import { IamStore } from '../../../stores/iam.store'

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss'],
})
export class ServiceListComponent implements OnInit, OnDestroy {
  @Input() isPublic = false

  orgListedSubscription: Subscription

  contentLoadedSubscription: Subscription

  noServicesAvailable = false

  constructor(
    public content: ContentService,
    public app: AppService,
    private iam: IamService,
    private iamStore: IamStore
  ) {}

  ngOnInit() {
    // subscribe for the organisation listed event
    combineLatest([
      this.content.servicesLoaded$.pipe(filter((loaded) => !!loaded)),
      this.iamStore.storeInitialised$.pipe(filter((errored) => errored !== undefined)),
    ])
      .pipe(
        take(1),
        map(() => {
          if (!this.content.content.services?.length) {
            this.noServicesAvailable = true
          } else {
            this.noServicesAvailable = false
            this.content.content.services = this.checkPermissionsForServices()
          }
        })
      )
      .subscribe()
  }

  private checkPermissionsForServices(): ContentfulService[] {
    const filteredServices: ContentfulService[] = []

    this.content.content.services?.forEach((s) => {
      // If the service can only be booked by the API the user shall not see the service at all
      if (s.fields.onlyBookableByApi) {
        return
      }

      if (!s.fields.hasAccess) {
        // In this case the access is not restricted and the service should be part of the current content
        filteredServices.push(s)
      } else {
        s.fields.hasAccess.forEach((hA) => {
          // if user is part of the access list add the service because the user is allowed to selection it
          if (
            hA.fields.userId === this.iamStore.currentUser?.data.userId &&
            this.iamStore.currentOrganisation &&
            hA.fields.orgId === this.iamStore.currentOrganisation.organizationId
          ) {
            filteredServices.push(s)
          }
        })
      }
    })

    return filteredServices
  }

  ngOnDestroy(): void {
    this.orgListedSubscription?.unsubscribe()
    this.contentLoadedSubscription?.unsubscribe()
  }
}
